export default __webpack_public_path__ + "static/media/Lohrmann.6b051f45.png";